/**
 * Mirror of customer-api/src/paymentSettlement.js for Customer HQ.
 * Customer paid ≠ driver paid / admin Process Payments rows.
 */

import { isDepositReceiverCustomerPaid } from "./orderDeposit.js";

const CUSTOMER_TO_QT_RECEIVERS = new Set([
  "customerbank-to-qiktruck",
  "customerpayfast-to-qiktruck",
  "driver-to-qiktruck",
]);

export function normalizeGatewayId(gatewaypaymentid) {
  return String(gatewaypaymentid || "")
    .replace(/\s/g, "")
    .toLowerCase();
}

export function isAdminDriverPayoutPayment(order = {}) {
  const status = String(order.paymentstatus || "").toUpperCase();
  if (status === "DRIVER_PAYOUT") return true;
  return normalizeGatewayId(order.gatewaypaymentid).startsWith("qiktruckadmin-");
}

export function isCustomerPaidToQikTruck(order = {}) {
  if (!order) return false;
  const receiver = String(order.paymentreceiver || "").toLowerCase();
  if (receiver === "deposit-to-qiktruck") {
    return isDepositReceiverCustomerPaid(order);
  }
  if (CUSTOMER_TO_QT_RECEIVERS.has(receiver)) return true;

  if (
    order.customerpaid === 1 ||
    order.customerpaid === "1" ||
    order.customerpaid === true
  ) {
    return true;
  }

  if (isAdminDriverPayoutPayment(order)) return false;

  // Billing API may already map status to "Paid" / "Due"
  const status = String(order.status || order.paymentstatus || "").toUpperCase();
  if (status === "DUE" || status === "UNPAID") return false;
  return status === "COMPLETE" || status === "PAID" || status === "SUCCESS";
}
